import NextWrapper from '@/components/layouts/Containers/NextWrapper/NextWrapper';
import HomeQRs from '@/reactPages/Home/QRs/HomeQRs';

export const meta = {
  title: 'Дом - как решить жилищный вопрос',
};
const About = () => {
  return (
    <>
      <NextWrapper meta={meta}></NextWrapper>
      <HomeQRs></HomeQRs>
    </>
  );
};

export default About;
